import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Announcement {
  announcement_name: string;
  date: string;
  image_id: string;
  institution: string;
  link: string | null;
  screen_image_id: string;
  _id: string;
}
const announcementsSlice = createSlice({
  name: "announcements",
  initialState: [] as Announcement[],
  reducers: {
    setAnnouncements: (_, action: PayloadAction<any>) => {
      return action.payload;
    },
  },
});
export const { setAnnouncements } = announcementsSlice.actions;

export default announcementsSlice.reducer;
